export enum CUSTOMER_TAGS {
  FIRST_ORDER_FORM_STARTED = 'first_order_form_started',
  FIRST_ORDER_FORM_FINISHED = 'first_order_form_finished',
}
